import React, { Fragment } from "react";
import styled from "@emotion/styled";
import RateVariation from "../common/RateVariation";
import {
  TypographyT19,
  TypographyT20,
  TypographyT21,
} from "Components/Common/Typography/index";
import { Spacer } from "Components/Common/Spacer/index";

const RateInfoCard = (props) => {
  const { rate, labelOfL, isActive, isLActive, showRateVariation } = props;
  return (
    <Fragment>
      <RateInfoCardWrapper isActive={isActive}>
        <TypographyT19 variant="h5" color={!!isActive ? "#FFFFFF" : ""}>
          <span style={{ fontFamily: "Roboto", paddingRight: "5px" }}>₹</span>
          {rate}
        </TypographyT19>
        <Spacer spacing={"1px"} />
        <TypographyT20 variant="h6" color={!!isActive ? "#FFFFFF" : ""}>
          /MT
        </TypographyT20>
        {!!showRateVariation && (
          <Fragment>
            <Spacer spacing={"6px"} />
            <RateVariation rate={"-1017"} isActive={isActive} />
          </Fragment>
        )}

        <Spacer spacing={"6px"} />
        <TypographyT21 variant="h6" bgColor={!!isLActive ? "#6FD87C" : ""}>
          {labelOfL}
        </TypographyT21>
      </RateInfoCardWrapper>
    </Fragment>
  );
};

export default RateInfoCard;

const RateInfoCardWrapper = styled("div")`
  display: flex;
  align-items: center;
  background-color: ${({ isActive }) => (!!isActive ? "#4E9757" : "")};
  padding: 5px 10px;
  border-radius: 4px;
  width: fit-content;
`;
